"use client";

// src/collection-legacy.tsx
import _toConsumableArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _inherits from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _getPrototypeOf from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _get from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/get.js";
import _wrapNativeSuper from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _keys;
var _excluded = ["scope", "children"],
  _excluded2 = ["state"],
  _excluded3 = ["scope", "children"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { createContextScope } from "@radix-ui/react-context";
import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { createSlot } from "@radix-ui/react-slot";
import { jsx } from "react/jsx-runtime";
function createCollection(name) {
  var PROVIDER_NAME = name + "CollectionProvider";
  var _createContextScope = createContextScope(PROVIDER_NAME),
    _createContextScope2 = _slicedToArray(_createContextScope, 2),
    createCollectionContext = _createContextScope2[0],
    createCollectionScope = _createContextScope2[1];
  var _createCollectionCont = createCollectionContext(PROVIDER_NAME, {
      collectionRef: {
        current: null
      },
      itemMap: /* @__PURE__ */new Map()
    }),
    _createCollectionCont2 = _slicedToArray(_createCollectionCont, 2),
    CollectionProviderImpl = _createCollectionCont2[0],
    useCollectionContext = _createCollectionCont2[1];
  var CollectionProvider = function CollectionProvider(props) {
    var scope = props.scope,
      children = props.children;
    var ref = React.useRef(null);
    var itemMap = React.useRef(/* @__PURE__ */new Map()).current;
    return /* @__PURE__ */jsx(CollectionProviderImpl, {
      scope: scope,
      itemMap: itemMap,
      collectionRef: ref,
      children: children
    });
  };
  CollectionProvider.displayName = PROVIDER_NAME;
  var COLLECTION_SLOT_NAME = name + "CollectionSlot";
  var CollectionSlotImpl = createSlot(COLLECTION_SLOT_NAME);
  var CollectionSlot = React.forwardRef(function (props, forwardedRef) {
    var scope = props.scope,
      children = props.children;
    var context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    var composedRefs = useComposedRefs(forwardedRef, context.collectionRef);
    return /* @__PURE__ */jsx(CollectionSlotImpl, {
      ref: composedRefs,
      children: children
    });
  });
  CollectionSlot.displayName = COLLECTION_SLOT_NAME;
  var ITEM_SLOT_NAME = name + "CollectionItemSlot";
  var ITEM_DATA_ATTR = "data-radix-collection-item";
  var CollectionItemSlotImpl = createSlot(ITEM_SLOT_NAME);
  var CollectionItemSlot = React.forwardRef(function (props, forwardedRef) {
    var scope = props.scope,
      children = props.children,
      itemData = _objectWithoutProperties(props, _excluded);
    var ref = React.useRef(null);
    var composedRefs = useComposedRefs(forwardedRef, ref);
    var context = useCollectionContext(ITEM_SLOT_NAME, scope);
    React.useEffect(function () {
      context.itemMap.set(ref, _objectSpread({
        ref: ref
      }, itemData));
      return function () {
        return void context.itemMap.delete(ref);
      };
    });
    return /* @__PURE__ */jsx(CollectionItemSlotImpl, _objectSpread(_objectSpread({}, _defineProperty({}, ITEM_DATA_ATTR, "")), {}, {
      ref: composedRefs,
      children: children
    }));
  });
  CollectionItemSlot.displayName = ITEM_SLOT_NAME;
  function useCollection(scope) {
    var context = useCollectionContext(name + "CollectionConsumer", scope);
    var getItems = React.useCallback(function () {
      var collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      var orderedNodes = Array.from(collectionNode.querySelectorAll("[".concat(ITEM_DATA_ATTR, "]")));
      var items = Array.from(context.itemMap.values());
      var orderedItems = items.sort(function (a, b) {
        return orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current);
      });
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }
  return [{
    Provider: CollectionProvider,
    Slot: CollectionSlot,
    ItemSlot: CollectionItemSlot
  }, useCollection, createCollectionScope];
}

// src/collection.tsx
import React2 from "react";
import { createContextScope as createContextScope2 } from "@radix-ui/react-context";
import { useComposedRefs as useComposedRefs2 } from "@radix-ui/react-compose-refs";
import { createSlot as createSlot2 } from "@radix-ui/react-slot";

// src/ordered-dictionary.ts
var __instanciated = /* @__PURE__ */new WeakMap();
var OrderedDict = (_keys = /*#__PURE__*/new WeakMap(), /*#__PURE__*/function (_Map) {
  function _OrderedDict(entries) {
    var _this;
    _classCallCheck(this, _OrderedDict);
    _this = _callSuper(this, _OrderedDict, [entries]);
    _classPrivateFieldInitSpec(_this, _keys, void 0);
    _classPrivateFieldSet(_keys, _this, _toConsumableArray(_superPropGet((_this, _OrderedDict), "keys", _this, 3)([])));
    __instanciated.set(_this, true);
    return _this;
  }
  _inherits(_OrderedDict, _Map);
  return _createClass(_OrderedDict, [{
    key: "set",
    value: function set(key, value) {
      if (__instanciated.get(this)) {
        if (this.has(key)) {
          _classPrivateFieldGet(_keys, this)[_classPrivateFieldGet(_keys, this).indexOf(key)] = key;
        } else {
          _classPrivateFieldGet(_keys, this).push(key);
        }
      }
      _superPropGet(_OrderedDict, "set", this, 3)([key, value]);
      return this;
    }
  }, {
    key: "insert",
    value: function insert(index, key, value) {
      var has = this.has(key);
      var length = _classPrivateFieldGet(_keys, this).length;
      var relativeIndex = toSafeInteger(index);
      var actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
      var safeIndex = actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
      if (safeIndex === this.size || has && safeIndex === this.size - 1 || safeIndex === -1) {
        this.set(key, value);
        return this;
      }
      var size = this.size + (has ? 0 : 1);
      if (relativeIndex < 0) {
        actualIndex++;
      }
      var keys = _toConsumableArray(_classPrivateFieldGet(_keys, this));
      var nextValue;
      var shouldSkip = false;
      for (var i = actualIndex; i < size; i++) {
        if (actualIndex === i) {
          var nextKey = keys[i];
          if (keys[i] === key) {
            nextKey = keys[i + 1];
          }
          if (has) {
            this.delete(key);
          }
          nextValue = this.get(nextKey);
          this.set(key, value);
        } else {
          if (!shouldSkip && keys[i - 1] === key) {
            shouldSkip = true;
          }
          var currentKey = keys[shouldSkip ? i : i - 1];
          var currentValue = nextValue;
          nextValue = this.get(currentKey);
          this.delete(currentKey);
          this.set(currentKey, currentValue);
        }
      }
      return this;
    }
  }, {
    key: "with",
    value: function _with(index, key, value) {
      var copy = new _OrderedDict(this);
      copy.insert(index, key, value);
      return copy;
    }
  }, {
    key: "before",
    value: function before(key) {
      var index = _classPrivateFieldGet(_keys, this).indexOf(key) - 1;
      if (index < 0) {
        return void 0;
      }
      return this.entryAt(index);
    }
    /**
     * Sets a new key-value pair at the position before the given key.
     */
  }, {
    key: "setBefore",
    value: function setBefore(key, newKey, value) {
      var index = _classPrivateFieldGet(_keys, this).indexOf(key);
      if (index === -1) {
        return this;
      }
      return this.insert(index, newKey, value);
    }
  }, {
    key: "after",
    value: function after(key) {
      var index = _classPrivateFieldGet(_keys, this).indexOf(key);
      index = index === -1 || index === this.size - 1 ? -1 : index + 1;
      if (index === -1) {
        return void 0;
      }
      return this.entryAt(index);
    }
    /**
     * Sets a new key-value pair at the position after the given key.
     */
  }, {
    key: "setAfter",
    value: function setAfter(key, newKey, value) {
      var index = _classPrivateFieldGet(_keys, this).indexOf(key);
      if (index === -1) {
        return this;
      }
      return this.insert(index + 1, newKey, value);
    }
  }, {
    key: "first",
    value: function first() {
      return this.entryAt(0);
    }
  }, {
    key: "last",
    value: function last() {
      return this.entryAt(-1);
    }
  }, {
    key: "clear",
    value: function clear() {
      _classPrivateFieldSet(_keys, this, []);
      return _superPropGet(_OrderedDict, "clear", this, 3)([]);
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var deleted = _superPropGet(_OrderedDict, "delete", this, 3)([key]);
      if (deleted) {
        _classPrivateFieldGet(_keys, this).splice(_classPrivateFieldGet(_keys, this).indexOf(key), 1);
      }
      return deleted;
    }
  }, {
    key: "deleteAt",
    value: function deleteAt(index) {
      var key = this.keyAt(index);
      if (key !== void 0) {
        return this.delete(key);
      }
      return false;
    }
  }, {
    key: "at",
    value: function at(index) {
      var key = _at(_classPrivateFieldGet(_keys, this), index);
      if (key !== void 0) {
        return this.get(key);
      }
    }
  }, {
    key: "entryAt",
    value: function entryAt(index) {
      var key = _at(_classPrivateFieldGet(_keys, this), index);
      if (key !== void 0) {
        return [key, this.get(key)];
      }
    }
  }, {
    key: "indexOf",
    value: function indexOf(key) {
      return _classPrivateFieldGet(_keys, this).indexOf(key);
    }
  }, {
    key: "keyAt",
    value: function keyAt(index) {
      return _at(_classPrivateFieldGet(_keys, this), index);
    }
  }, {
    key: "from",
    value: function from(key, offset) {
      var index = this.indexOf(key);
      if (index === -1) {
        return void 0;
      }
      var dest = index + offset;
      if (dest < 0) dest = 0;
      if (dest >= this.size) dest = this.size - 1;
      return this.at(dest);
    }
  }, {
    key: "keyFrom",
    value: function keyFrom(key, offset) {
      var index = this.indexOf(key);
      if (index === -1) {
        return void 0;
      }
      var dest = index + offset;
      if (dest < 0) dest = 0;
      if (dest >= this.size) dest = this.size - 1;
      return this.keyAt(dest);
    }
  }, {
    key: "find",
    value: function find(predicate, thisArg) {
      var index = 0;
      var _iterator = _createForOfIteratorHelper(this),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          if (Reflect.apply(predicate, thisArg, [entry, index, this])) {
            return entry;
          }
          index++;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return void 0;
    }
  }, {
    key: "findIndex",
    value: function findIndex(predicate, thisArg) {
      var index = 0;
      var _iterator2 = _createForOfIteratorHelper(this),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var entry = _step2.value;
          if (Reflect.apply(predicate, thisArg, [entry, index, this])) {
            return index;
          }
          index++;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return -1;
    }
  }, {
    key: "filter",
    value: function filter(predicate, thisArg) {
      var entries = [];
      var index = 0;
      var _iterator3 = _createForOfIteratorHelper(this),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var entry = _step3.value;
          if (Reflect.apply(predicate, thisArg, [entry, index, this])) {
            entries.push(entry);
          }
          index++;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return new _OrderedDict(entries);
    }
  }, {
    key: "map",
    value: function map(callbackfn, thisArg) {
      var entries = [];
      var index = 0;
      var _iterator4 = _createForOfIteratorHelper(this),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var entry = _step4.value;
          entries.push([entry[0], Reflect.apply(callbackfn, thisArg, [entry, index, this])]);
          index++;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return new _OrderedDict(entries);
    }
  }, {
    key: "reduce",
    value: function reduce() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var callbackfn = args[0],
        initialValue = args[1];
      var index = 0;
      var accumulator = initialValue !== null && initialValue !== void 0 ? initialValue : this.at(0);
      var _iterator5 = _createForOfIteratorHelper(this),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var entry = _step5.value;
          if (index === 0 && args.length === 1) {
            accumulator = entry;
          } else {
            accumulator = Reflect.apply(callbackfn, this, [accumulator, entry, index, this]);
          }
          index++;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return accumulator;
    }
  }, {
    key: "reduceRight",
    value: function reduceRight() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var callbackfn = args[0],
        initialValue = args[1];
      var accumulator = initialValue !== null && initialValue !== void 0 ? initialValue : this.at(-1);
      for (var index = this.size - 1; index >= 0; index--) {
        var entry = this.at(index);
        if (index === this.size - 1 && args.length === 1) {
          accumulator = entry;
        } else {
          accumulator = Reflect.apply(callbackfn, this, [accumulator, entry, index, this]);
        }
      }
      return accumulator;
    }
  }, {
    key: "toSorted",
    value: function toSorted(compareFn) {
      var entries = _toConsumableArray(this.entries()).sort(compareFn);
      return new _OrderedDict(entries);
    }
  }, {
    key: "toReversed",
    value: function toReversed() {
      var reversed = new _OrderedDict();
      for (var index = this.size - 1; index >= 0; index--) {
        var key = this.keyAt(index);
        var element = this.get(key);
        reversed.set(key, element);
      }
      return reversed;
    }
  }, {
    key: "toSpliced",
    value: function toSpliced() {
      var entries = _toConsumableArray(this.entries());
      entries.splice.apply(entries, arguments);
      return new _OrderedDict(entries);
    }
  }, {
    key: "slice",
    value: function slice(start, end) {
      var result = new _OrderedDict();
      var stop = this.size - 1;
      if (start === void 0) {
        return result;
      }
      if (start < 0) {
        start = start + this.size;
      }
      if (end !== void 0 && end > 0) {
        stop = end - 1;
      }
      for (var index = start; index <= stop; index++) {
        var key = this.keyAt(index);
        var element = this.get(key);
        result.set(key, element);
      }
      return result;
    }
  }, {
    key: "every",
    value: function every(predicate, thisArg) {
      var index = 0;
      var _iterator6 = _createForOfIteratorHelper(this),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var entry = _step6.value;
          if (!Reflect.apply(predicate, thisArg, [entry, index, this])) {
            return false;
          }
          index++;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return true;
    }
  }, {
    key: "some",
    value: function some(predicate, thisArg) {
      var index = 0;
      var _iterator7 = _createForOfIteratorHelper(this),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var entry = _step7.value;
          if (Reflect.apply(predicate, thisArg, [entry, index, this])) {
            return true;
          }
          index++;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return false;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(Map)));
function _at(array, index) {
  if ("at" in Array.prototype) {
    return Array.prototype.at.call(array, index);
  }
  var actualIndex = toSafeIndex(array, index);
  return actualIndex === -1 ? void 0 : array[actualIndex];
}
function toSafeIndex(array, index) {
  var length = array.length;
  var relativeIndex = toSafeInteger(index);
  var actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
  return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}
function toSafeInteger(number) {
  return number !== number || number === 0 ? 0 : Math.trunc(number);
}

// src/collection.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
function createCollection2(name) {
  var PROVIDER_NAME = name + "CollectionProvider";
  var _createContextScope3 = createContextScope2(PROVIDER_NAME),
    _createContextScope4 = _slicedToArray(_createContextScope3, 2),
    createCollectionContext = _createContextScope4[0],
    createCollectionScope = _createContextScope4[1];
  var _createCollectionCont3 = createCollectionContext(PROVIDER_NAME, {
      collectionElement: null,
      collectionRef: {
        current: null
      },
      collectionRefObject: {
        current: null
      },
      itemMap: new OrderedDict(),
      setItemMap: function setItemMap() {
        return void 0;
      }
    }),
    _createCollectionCont4 = _slicedToArray(_createCollectionCont3, 2),
    CollectionContextProvider = _createCollectionCont4[0],
    useCollectionContext = _createCollectionCont4[1];
  var CollectionProvider = function CollectionProvider(_ref) {
    var state = _ref.state,
      props = _objectWithoutProperties(_ref, _excluded2);
    return state ? /* @__PURE__ */jsx2(CollectionProviderImpl, _objectSpread(_objectSpread({}, props), {}, {
      state: state
    })) : /* @__PURE__ */jsx2(CollectionInit, _objectSpread({}, props));
  };
  CollectionProvider.displayName = PROVIDER_NAME;
  var CollectionInit = function CollectionInit(props) {
    var state = useInitCollection();
    return /* @__PURE__ */jsx2(CollectionProviderImpl, _objectSpread(_objectSpread({}, props), {}, {
      state: state
    }));
  };
  CollectionInit.displayName = PROVIDER_NAME + "Init";
  var CollectionProviderImpl = function CollectionProviderImpl(props) {
    var scope = props.scope,
      children = props.children,
      state = props.state;
    var ref = React2.useRef(null);
    var _React2$useState = React2.useState(null),
      _React2$useState2 = _slicedToArray(_React2$useState, 2),
      collectionElement = _React2$useState2[0],
      setCollectionElement = _React2$useState2[1];
    var composeRefs = useComposedRefs2(ref, setCollectionElement);
    var _state = _slicedToArray(state, 2),
      itemMap = _state[0],
      setItemMap = _state[1];
    React2.useEffect(function () {
      if (!collectionElement) return;
      var observer = getChildListObserver(function () {});
      observer.observe(collectionElement, {
        childList: true,
        subtree: true
      });
      return function () {
        observer.disconnect();
      };
    }, [collectionElement]);
    return /* @__PURE__ */jsx2(CollectionContextProvider, {
      scope: scope,
      itemMap: itemMap,
      setItemMap: setItemMap,
      collectionRef: composeRefs,
      collectionRefObject: ref,
      collectionElement: collectionElement,
      children: children
    });
  };
  CollectionProviderImpl.displayName = PROVIDER_NAME + "Impl";
  var COLLECTION_SLOT_NAME = name + "CollectionSlot";
  var CollectionSlotImpl = createSlot2(COLLECTION_SLOT_NAME);
  var CollectionSlot = React2.forwardRef(function (props, forwardedRef) {
    var scope = props.scope,
      children = props.children;
    var context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    var composedRefs = useComposedRefs2(forwardedRef, context.collectionRef);
    return /* @__PURE__ */jsx2(CollectionSlotImpl, {
      ref: composedRefs,
      children: children
    });
  });
  CollectionSlot.displayName = COLLECTION_SLOT_NAME;
  var ITEM_SLOT_NAME = name + "CollectionItemSlot";
  var ITEM_DATA_ATTR = "data-radix-collection-item";
  var CollectionItemSlotImpl = createSlot2(ITEM_SLOT_NAME);
  var CollectionItemSlot = React2.forwardRef(function (props, forwardedRef) {
    var scope = props.scope,
      children = props.children,
      itemData = _objectWithoutProperties(props, _excluded3);
    var ref = React2.useRef(null);
    var _React2$useState3 = React2.useState(null),
      _React2$useState4 = _slicedToArray(_React2$useState3, 2),
      element = _React2$useState4[0],
      setElement = _React2$useState4[1];
    var composedRefs = useComposedRefs2(forwardedRef, ref, setElement);
    var context = useCollectionContext(ITEM_SLOT_NAME, scope);
    var setItemMap = context.setItemMap;
    var itemDataRef = React2.useRef(itemData);
    if (!shallowEqual(itemDataRef.current, itemData)) {
      itemDataRef.current = itemData;
    }
    var memoizedItemData = itemDataRef.current;
    React2.useEffect(function () {
      var itemData2 = memoizedItemData;
      setItemMap(function (map) {
        if (!element) {
          return map;
        }
        if (!map.has(element)) {
          map.set(element, _objectSpread(_objectSpread({}, itemData2), {}, {
            element: element
          }));
          return map.toSorted(sortByDocumentPosition);
        }
        return map.set(element, _objectSpread(_objectSpread({}, itemData2), {}, {
          element: element
        })).toSorted(sortByDocumentPosition);
      });
      return function () {
        setItemMap(function (map) {
          if (!element || !map.has(element)) {
            return map;
          }
          map.delete(element);
          return new OrderedDict(map);
        });
      };
    }, [element, memoizedItemData, setItemMap]);
    return /* @__PURE__ */jsx2(CollectionItemSlotImpl, _objectSpread(_objectSpread({}, _defineProperty({}, ITEM_DATA_ATTR, "")), {}, {
      ref: composedRefs,
      children: children
    }));
  });
  CollectionItemSlot.displayName = ITEM_SLOT_NAME;
  function useInitCollection() {
    return React2.useState(new OrderedDict());
  }
  function useCollection(scope) {
    var _useCollectionContext = useCollectionContext(name + "CollectionConsumer", scope),
      itemMap = _useCollectionContext.itemMap;
    return itemMap;
  }
  var functions = {
    createCollectionScope: createCollectionScope,
    useCollection: useCollection,
    useInitCollection: useInitCollection
  };
  return [{
    Provider: CollectionProvider,
    Slot: CollectionSlot,
    ItemSlot: CollectionItemSlot
  }, functions];
}
function shallowEqual(a, b) {
  if (a === b) return true;
  if (typeof a !== "object" || typeof b !== "object") return false;
  if (a == null || b == null) return false;
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;
  for (var _i = 0, _keysA = keysA; _i < _keysA.length; _i++) {
    var key = _keysA[_i];
    if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
    if (a[key] !== b[key]) return false;
  }
  return true;
}
function isElementPreceding(a, b) {
  return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
function sortByDocumentPosition(a, b) {
  return !a[1].element || !b[1].element ? 0 : isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}
function getChildListObserver(callback) {
  var observer = new MutationObserver(function (mutationsList) {
    var _iterator8 = _createForOfIteratorHelper(mutationsList),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var mutation = _step8.value;
        if (mutation.type === "childList") {
          callback();
          return;
        }
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  });
  return observer;
}
export { createCollection, createCollection2 as unstable_createCollection };